module.exports = function() {
  return new Worker(__webpack_public_path__ + "6b2fde377dee9dcf49a1.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/worker-loader/dist/cjs.js!./src/app/api/toc.worker.js
// module id = 1502
// module chunks = 0